/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useTreemapData } from "../data/useTreeMapData";
import { useTreemapChart } from "../transformers/useTreemapChart";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useParameter, useDictionaryItem, useExport, useSubscriptionSource } from "../../../shared";
import { footnotes } from "../utils/footnotes";
import { dictionaryService } from "../../../dataFlow";
import { shortCommodities } from "../utils/shortCommodities";
import { shortCountries } from "../utils/shortCountries";
import { useChartTitle } from "../hooks/useChartTitle";
import { useExportSource } from "../hooks/useExportSource";
import { groupBy } from "lodash";

export const ComponentTreemap: React.FC<{ context: ContextReport1 }> = (props) => {
  const context = props.context;
  const olapCurrentYearCountriesResult = useHookSubscribe(null, context.olapCurrentYearCountriesResult$);
  const olapCurrentYearWorldResult = useHookSubscribe(null, context.olapCurrentYearWorldResult$);
  const olapLastYearCountriesResult = useHookSubscribe(null, context.olapLastYearCountriesResult$);
  const olapLastYearWorldResult = useHookSubscribe(null, context.olapLastYearWorldResult$);
  const commoditiesCountries = useHookSubscribe(new Map(), context.commoditiesCountries$);

  const source = useHookSubscribe(null, context.sources$);
  useExportSource(source);
  useSubscriptionSource(source);

  const currentYearCountriesData = useTreemapData(olapCurrentYearCountriesResult);
  const currentYearWorldData = useTreemapData(olapCurrentYearWorldResult);
  const lastYearCountriesData = useTreemapData(olapLastYearCountriesResult);
  const lastYearWorldData = useTreemapData(olapLastYearWorldResult);

  const chartData = useTreemapChart(
    commoditiesCountries,
    currentYearWorldData,
    currentYearCountriesData,
    lastYearWorldData,
    lastYearCountriesData
  );

  const worldRows = currentYearWorldData?.rows;
  const worldValue = worldRows?.flatMap((r) => r.points).reduce((sum, point) => sum + point["share_of"], 0) || 0;

  const chartTitle = useChartTitle(worldValue);

  const hasData = chartData && currentYearCountriesData && currentYearWorldData && lastYearCountriesData && lastYearWorldData;
  if (!hasData || context.readyState === ComponentContextReadyState.Loading) {
    return <ComponentPreloader />;
  }

  const commodities = currentYearWorldData!.columns.flatMap((x) => x.headers).map((x) => (x.name ? x.name[9] : ""));
  const countries = currentYearCountriesData!.rows.map((x) => x.attributes[currentYearCountriesData!.rowsHeaders[0]!.id]);

  return (
    <>
      <ComponentTitle>{chartTitle}</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} loader={<ComponentPreloader />} />
      <ComponentFootnote>*{footnotes(commodities, shortCommodities)}</ComponentFootnote>
      <ComponentFootnote>**{footnotes(countries, shortCountries)}</ComponentFootnote>
    </>
  );
};
